/**
 * CentroDeCusto
 * @author gabrielgil
 */
import {$, ID, Resource} from 'simpli-web-sdk'

export default class CentroDeCusto extends Resource {
  readonly $name: string = 'CentroDeCusto'

  readonly $endpoint: string = '/user/me/centro-de-custo'

  get $id() {
    return this.idCentroDeCustoPk
  }
  set $id(val: ID) {
    this.idCentroDeCustoPk = val
  }

  get $tag() {
    return this.nome
  }

  idCentroDeCustoPk: ID = 0

  nome: string = ''
}
